// extracted by mini-css-extract-plugin
module.exports = {"tab-bar":"style_tab-bar__11cYt","button":"style_button__BxSAm","active":"style_active__2csuB","new":"style_new__2Tt8I"};